<script lang="ts">
	import { DataHandlerFolder, Media, Folder } from "luxedo-data"
	import { FolderIcon } from "luxedo-icons"
	import { Toast } from "toaster"
	import { DragController, type DraggableContent } from "../../../../stores/DragContext"
	import { FileSystemMedia } from "../../../../modules/file-system/FileSystemMedia"
	import { TileLabel } from "luxedo-comps"
	import {
		ContextMenuButton,
		triggerContextMenuWithGenerator,
		type ContextMenuOptions,
	} from "context-menu"
	import { CTXOptions } from "../../../../modules/ctx-menu/ContextMenuOptions"

	interface Props {
		folder: Folder
		onClick: (folder: Folder) => void
	}

	let { folder, onClick }: Props = $props()

	let isDraggingOver = false
	let isDragging = $state(false)

	function onDragStart() {
		isDragging = true
	}

	function onDragEnd() {
		isDragging = false
	}

	function onDragLeave(e: DragEvent) {
		isDraggingOver = false
	}

	function onDragOver(e: DragEvent) {
		if (!(DragController.dragContent instanceof Media)) return
		isDraggingOver = true
	}

	async function onRename(newName: string) {
		try {
			await DataHandlerFolder.rename(folder, newName)
			Toast.success("Folder renamed.")
		} catch (e) {
			console.error("[ERROR] ", e)

			Toast.error("There was an error renaming this folder, please try again.")
		}
	}

	async function onDrop(e: DragEvent, content: DraggableContent) {
		if (!(content instanceof Media || content instanceof Folder)) return
		if (content === folder) return

		try {
			// @ts-ignore
			await FileSystemMedia.move(content, folder)
			Toast.success("Media successfully relocated.")
		} catch (e) {
			console.error("[ERROR] ", e)

			Toast.error("Unable to move content, please try again.")
		}
	}
	const generateCtxMenuOpts = (): ContextMenuOptions => {
		return CTXOptions.Folder.createOptions(folder)
	}
</script>

<div
	class="tile-container {isDragging ? 'is-dragging' : ''}"
	id="folder-tile-{folder.id}"
	role="application"
	ondragend={DragController.onDragEnd(onDragEnd)}
	ondragstart={DragController.onDragStart(folder, onDragStart)}
	ontouchstart={DragController.onDragStart(folder, onDragStart)}
	ontouchend={DragController.onDragEnd(onDragEnd)}
	ontouchcancel={DragController.onDragEnd(onDragEnd)}
	ondragleave={onDragLeave}
	ondragover={DragController.onDragOver(onDragOver)}
	ondrop={DragController.onDrop(onDrop)}
	onkeydown={undefined}
	ondblclick={() => onClick(folder)}
	onclick={() => onClick(folder)}
	oncontextmenu={triggerContextMenuWithGenerator(generateCtxMenuOpts)}
	draggable={true}
>
	<div class="ctx-menu-btn">
		<ContextMenuButton onClick={triggerContextMenuWithGenerator(generateCtxMenuOpts)} />
	</div>
	<div class="tile">
		<FolderIcon strokeColor="var(--color-text)" />
	</div>
	<div class="tile-label-container">
		<TileLabel file={folder} {onRename} />
		<span class="media-type"> Folder </span>
	</div>
</div>

<style>
	.tile-container:global(.focused) .tile {
		border-color: var(--color-main);
		border-width: 4px;
	}

	.tile {
		user-select: none;
		display: flex;
		align-items: center;
		justify-content: center;
		transition:
			border-color 250ms,
			border-width 250ms;
	}

	.tile :global(svg) {
		width: 90%;
		height: 90%;
	}
</style>
